import React from 'react';
import './footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className='container-footer'>
      <div className='container-fluid'>
        <div className='row first-row'>
          <div className='col-md-9 col-12'>
            <div className='footer_logo_numbers'>
              <div className='footer_logo'>
                <img src='https://cdn.hidalgo.gob.mx/gobierno/images/logos/logo_gob.png'alt="" />
                 </div>
                   <div className='footer_sociales'>
              <a href='https://www.facebook.com/MovilidadHgo/?locale=es_LA' target="_blank"rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
              <a href='https://www.instagram.com/movilidad_hgo/'><i class="fa-brands fa-instagram"></i></a>
              <a href='https://twitter.com/MovilidadHgo/'><i class="fa-brands fa-x-twitter fa-2x"></i></a>
              </div>
  
               <div className='footer_numbers'>
                <div> 
                  <p>Consultar:</p>
                  <a href='https://gobierno.hidalgo.gob.mx/AvisoPrivacidad' target="_blank"rel="noopener noreferrer"><p className='privacy-link'>Aviso de privacidad</p></a>
               </div>
                <div>
                  <p>911</p>
                  <p>Emergencia</p>
                </div>
                <div>
                  <p>089</p>
                  <p>Denuncia Anónima</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-3 col-12'>
            <div className='footer_contacto'>
              <h6>Contacto:</h6>
              <p>Calle 16 de enero de 1869, S/N. Colonia Periodistas,
              Pachuca de Soto, Hidalgo. C.P. 42060</p>
              <p>Telefono (771) 717 6000 Ext. 1827</p>
            </div>
          </div>
        </div>
        <hr className='hr-gob' />
        <div className='row second-row'>
        <div className='col-sm-9 col-12'> 
          <p>Copyrights © {currentYear} Todos los derechos reservados por Hidalgo de la Transformación</p>
          </div>        
        </div>
        </div>
    </div>
  )
}

export default Footer